export const spaceOnNumbers=(nb)=> {
    return nb?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }